import { NavRight } from "framework7-react";

export function NavRightEmpty() {
  return (
    <NavRight>
      <a className="icon-only" />
    </NavRight>
  );
}
